import { defineComponent as _defineComponent } from 'vue'
import { translate } from '@/util/commonFun'
import { onMounted, ref, watch } from 'vue'

import { getTaskList } from '../module/taskList'
import { TaskType } from '../types/taskCard'
import mEmpty from './m-empty.vue'
import mTaskCard from './m-task-card.vue'

interface PropsType {
  isVisible: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'm-refuse-history-modal',
  props: {
    isVisible: { type: Boolean }
  },
  emits: ['onClickConfirm', 'onClose', 'onPageChange'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  isVisible: boolean
}




const taskList = ref<TaskType[]>([])
const visible = ref(props.isVisible)
const typeList = ref([
  { label: 'taskPage.search.orderName', value: 'order_name' },
  { label: 'common.orderNo', value: 'order_num' },
  { label: 'taskPage.search.sender', value: 'sender' },
])
const searchType = ref('order_name')
const searchText = ref('')
const currentTaskPage = ref(1)
const total = ref(10)
const isLoading = ref(false)

function onModelClose() {
  emits('onClose', visible.value)
}

function handleSearch() {
  currentTaskPage.value = 1
  refetchCurrentPage(1)
}

function handleChangePage() {
  emits('onPageChange', currentTaskPage.value)
  refetchCurrentPage()
}

function refetchCurrentPage(page?: number) {
  if (searchText.value) {
    const obj: { [key: string]: string } = {}
    obj[searchType.value] = searchText.value
    fetchTaskList(page ? page : currentTaskPage.value, 1, obj)
  } else {
    fetchTaskList(page ? page : currentTaskPage.value, 1)
  }
}

async function fetchTaskList(
  page: number,
  current_step: number,
  extraInfo?: any
) {
  isLoading.value = true
  const payload = {
    current_step,
    page,
    limit: 6,
  }
  if (extraInfo) Object.assign(payload, extraInfo)
  const res = await getTaskList(payload)
  isLoading.value = false
  taskList.value = res.taskList
  total.value = res.total
}

function translateLang(key: string) {
  return translate(key)
}

onMounted(async () => {
  refetchCurrentPage(1)
})

watch(
  () => props.isVisible,
  (val) => {
    visible.value = val
    if (val) {
      currentTaskPage.value = 1
      refetchCurrentPage(1)
    }
  }
)

return { __sfc: true,props, emits, taskList, visible, typeList, searchType, searchText, currentTaskPage, total, isLoading, onModelClose, handleSearch, handleChangePage, refetchCurrentPage, fetchTaskList, translateLang, mEmpty, mTaskCard }
}

})